var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("test-template", {
        attrs: { testName: _vm.testName, testId: _vm.testId, test: _vm.test },
        on: { saveResults: _vm.getPhysicalActivityResults },
        scopedSlots: _vm._u([
          {
            key: "questions",
            fn: function() {
              return [
                _c("b-card", { staticClass: "neu-card" }, [
                  _c("h1", [_vm._v(_vm._s(_vm.cQ.intensity.toUpperCase()))]),
                  _vm._v(" "),
                  _c("h4", {
                    domProps: { innerHTML: _vm._s(_vm.cQ.question) }
                  }),
                  _vm._v(" "),
                  _vm.cQ.id === "q1" || _vm.cQ.id === "q3" || _vm.cQ.id === "q5"
                    ? _c(
                        "div",
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "d-flex justify-content-center"
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "d-inline-flex" },
                                    [
                                      _c(
                                        "b-row",
                                        [
                                          _c(
                                            "b-col",
                                            {
                                              attrs: {
                                                cols: "12",
                                                sm: "12",
                                                md: "6",
                                                lg: "6"
                                              }
                                            },
                                            [
                                              _c("base-input", {
                                                staticClass: "inputAnswer",
                                                attrs: {
                                                  type: "number",
                                                  placeholder: _vm.$t("days"),
                                                  min: 0,
                                                  max: 7
                                                },
                                                model: {
                                                  value: _vm.cQ.result,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.cQ,
                                                      "result",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "cQ.result"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _vm.cQ.result &&
                              _vm.cQ.result > 0 &&
                              _vm.cQ.result <= 7
                                ? _c(
                                    "b-col",
                                    {
                                      staticClass:
                                        "px-0 pt-1 px-md-5 pt-md-3 float-right m-auto",
                                      attrs: { xs: "12", lg: "8" }
                                    },
                                    [
                                      _c(
                                        "transition",
                                        { attrs: { name: "fade", appear: "" } },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-primary w-100",
                                              attrs: { type: "button" },
                                              on: {
                                                "~click": function($event) {
                                                  return _vm.$store.commit(
                                                    "tests/incrementSlide"
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "text-center" },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.cQ.result) +
                                                      " " +
                                                      _vm._s(_vm.$t("days"))
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "float-right m-auto"
                                                },
                                                [
                                                  _c("base-icon", {
                                                    attrs: {
                                                      src:
                                                        "/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg",
                                                      color: "white"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                : _vm.cQ.result == 0
                                ? _c(
                                    "b-col",
                                    {
                                      staticClass:
                                        "px-0 pt-1 px-md-5 pt-md-3 float-right m-auto",
                                      attrs: { xs: "12", lg: "8" }
                                    },
                                    [
                                      _c(
                                        "transition",
                                        { attrs: { name: "fade", appear: "" } },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-primary w-100",
                                              attrs: { type: "button" },
                                              on: {
                                                "~click": function($event) {
                                                  return _vm.$store.commit(
                                                    "tests/incrementSlide",
                                                    2
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "text-center" },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.cQ.result) +
                                                      " " +
                                                      _vm._s(_vm.$t("days"))
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "float-right m-auto"
                                                },
                                                [
                                                  _c("base-icon", {
                                                    attrs: {
                                                      src:
                                                        "/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg",
                                                      color: "white"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _c(
                        "div",
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "d-flex justify-content-center"
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "d-inline-flex" },
                                    [
                                      _c(
                                        "b-row",
                                        [
                                          _c(
                                            "b-col",
                                            {
                                              attrs: {
                                                cols: "12",
                                                sm: "12",
                                                md: "6",
                                                lg: "6"
                                              }
                                            },
                                            [
                                              _c(
                                                "base-input",
                                                {
                                                  staticClass: "inputAnswer",
                                                  attrs: {
                                                    type: "number",
                                                    placeholder: _vm.$t(
                                                      "tests.sleep-quality.hours"
                                                    ),
                                                    min: 0,
                                                    max: 23
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.physicalActivity.hour,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.physicalActivity,
                                                        "hour",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "physicalActivity.hour"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "template",
                                                    { slot: "append" },
                                                    [_c("span", [_vm._v("h")])]
                                                  )
                                                ],
                                                2
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-col",
                                            {
                                              attrs: {
                                                cols: "12",
                                                sm: "12",
                                                md: "6",
                                                lg: "6"
                                              }
                                            },
                                            [
                                              _c(
                                                "base-input",
                                                {
                                                  staticClass: "inputAnswer",
                                                  attrs: {
                                                    type: "number",
                                                    placeholder: _vm.$t(
                                                      "tests.sleep-quality.minutes"
                                                    ),
                                                    min: 0,
                                                    max: 59
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.physicalActivity
                                                        .minutes,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.physicalActivity,
                                                        "minutes",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "physicalActivity.minutes"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "template",
                                                    { slot: "append" },
                                                    [
                                                      _c("span", [
                                                        _vm._v("min")
                                                      ])
                                                    ]
                                                  )
                                                ],
                                                2
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              (_vm.physicalActivity.hour != 0 ||
                                _vm.physicalActivity.minutes != 0) &&
                              (_vm.physicalActivity.hour >= 0 &&
                                _vm.physicalActivity.minutes >= 0 &&
                                _vm.physicalActivity.hour < 24 &&
                                _vm.physicalActivity.minutes < 60)
                                ? _c(
                                    "b-col",
                                    {
                                      staticClass:
                                        "px-0 pt-1 px-md-5 pt-md-3 float-right m-auto",
                                      attrs: { xs: "12", lg: "8" }
                                    },
                                    [
                                      _c(
                                        "transition",
                                        { attrs: { name: "fade", appear: "" } },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-primary w-100",
                                              attrs: { type: "button" },
                                              on: {
                                                "~click": function($event) {
                                                  return _vm.calculateMinutes()
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "text-center" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.physicalActivity.hour
                                                    ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "tests.sleep-quality.hours"
                                                        )
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm.physicalActivity
                                                          .minutes
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "tests.sleep-quality.minutes"
                                                        )
                                                      )
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "float-right m-auto"
                                                },
                                                [
                                                  _c("base-icon", {
                                                    attrs: {
                                                      src:
                                                        "/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg",
                                                      color: "white"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                ])
              ]
            },
            proxy: true
          },
          {
            key: "results",
            fn: function() {
              return [
                _c(
                  "div",
                  { key: "topGraph", staticClass: "first" },
                  [
                    _c("h3", { staticClass: "subtitle-card text-center" }, [
                      _vm._v(
                        _vm._s(_vm.$t("tests.testResults")) +
                          " - " +
                          _vm._s(_vm.testName.toUpperCase())
                      )
                    ]),
                    _vm._v(" "),
                    _c("column-chart", {
                      attrs: {
                        lastYearResults: _vm.$store.state.tests.previousTestResults.slice(
                          -12
                        ),
                        testName: _vm.testName,
                        customChart: _vm.chartValues
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { key: "recapCard", staticClass: "second" },
                  [
                    _c("h4", [
                      _vm._v(
                        _vm._s(_vm.$t("tests.results")) +
                          " " +
                          _vm._s(_vm.month)
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "b-card",
                      { staticClass: "neu-card mean-result col-lg-7" },
                      [
                        _c("h3", { staticClass: "subtitle-card" }, [
                          _vm._v(" " + _vm._s(_vm.testName))
                        ]),
                        _vm._v(" "),
                        _c(
                          "h5",
                          {
                            staticClass: "subtitle-card",
                            style: "color: " + _vm.resultInfo.color
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.resultInfo.tag.toUpperCase())
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("p", {
                          staticClass: "p-white",
                          domProps: {
                            innerHTML: _vm._s(_vm.resultInfo.resultAnalysis)
                          }
                        })
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("small", [
                  _vm._v(
                    _vm._s(_vm.$t("tests.physical-activity.metsExplanation"))
                  )
                ])
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9e9c2642", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9e9c2642","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/selfEvaluationTests/PhysicalActivityTest.vue
// module id = 4166
// module chunks = 133